export const CURRENCY_INPUT_MAX_LENGTH = 15;
//# sourceMappingURL=currencyInput.js.map